export default __webpack_public_path__ + "static/media/blue-wave-bg.76d182de.png";